'use client';

import Link from 'next/link';
import { useEffect } from 'react';

export default function HeaderSection() {
  useEffect(() => {
    // Scroll effect
    const handleScroll = () => {
      if (window.scrollY > 100) {
        document.body.classList.add('scrolled');
      } else {
        document.body.classList.remove('scrolled');
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // initial check on load

    // ✅ Mobile nav toggle
    const mobileToggle = document.querySelector('.mobile-nav-toggle') as HTMLElement;

    const handleMobileToggle = () => {
      document.body.classList.toggle('mobile-nav-active');
      mobileToggle.classList.toggle('bi-list');
      mobileToggle.classList.toggle('bi-x');
    };

    mobileToggle?.addEventListener('click', handleMobileToggle);


       // ✅ Dropdown toggles (for mobile)
    const dropdownToggles = document.querySelectorAll('.navmenu .toggle-dropdown');
    const handlers: Array<(e: Event) => void> = [];

    dropdownToggles.forEach((toggle) => {
      const handler = (e: Event) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        const parentLi = (e.currentTarget as HTMLElement).closest('li');
        parentLi?.classList.toggle('active');
        const nestedUl = parentLi?.querySelector('ul');
        nestedUl?.classList.toggle('dropdown-active');
      };

      toggle.addEventListener('click', handler);
      handlers.push(handler);
    });

// ✅ Cleanup on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
      mobileToggle?.removeEventListener('click', handleMobileToggle);
      dropdownToggles.forEach((toggle, index) => {
        toggle.removeEventListener('click', handlers[index]);
      });
    };
  }, []);

  return (
    <header id="header" className="header d-flex align-items-center fixed-top">
      <div className="container-fluid container-xl position-relative d-flex align-items-center justify-content-between">

        <Link href="/" className="logo d-flex align-items-center me-auto me-lg-0">
          <h1 className="sitename">Smart Service</h1>
          <span>.</span>
        </Link>

        <nav id="navmenu" className="navmenu">
          <ul>
            <li><a href="#hero" className="active">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#portfolio">Portfolio</a></li>
            <li><a href="#team">Team</a></li>
           {/* <li className="dropdown">
              <a href="#"><span>Dropdown</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
              <ul>
                <li><a href="#">Dropdown 1</a></li>
                <li className="dropdown">
                  <a href="#"><span>Deep Dropdown</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href="#">Deep Dropdown 1</a></li>
                    <li><a href="#">Deep Dropdown 2</a></li>
                    <li><a href="#">Deep Dropdown 3</a></li>
                    <li><a href="#">Deep Dropdown 4</a></li>
                    <li><a href="#">Deep Dropdown 5</a></li>
                  </ul>
                </li>
                <li><a href="#">Dropdown 2</a></li>
                <li><a href="#">Dropdown 3</a></li>
                <li><a href="#">Dropdown 4</a></li>
              </ul>
            </li>*/}
            
            <li><a href="#contact">Contact</a></li>
          </ul>

          {/* ✅ Toggle Button */}
          <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
        </nav>

        <a className="btn-getstarted" href="#about">Get Started</a>
      </div>
    </header>
  );
}
